import FieldsValidation from '@components/Form/validationform/FieldsValidation';
import AppContext from '@services/Context';
import { TypesValidation } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Form, Icon } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React from 'react';

import IExecutionComponent from '../interfaces/IExecutionComponent';


export interface IPhotoExecutionProps extends IExecutionComponent {
  description: string;
  defaultValue: any[];
  repeat: boolean;
}

interface IPhotoExecutionState {
  photoComponent: any;
  valid: boolean[];
  defaultValue: any[];
  file: any[];
}
export default class PhotoExecutionComponent extends React.Component<IPhotoExecutionProps, IPhotoExecutionState> {
  constructor(props: IPhotoExecutionProps) {
    super(props);
    this.state = {
      photoComponent: [{ value: "" }],
      defaultValue: props.defaultValue,
      valid: [true],
      file: []
    }
  }
  componentDidMount(){
    const {defaultValue} = this.state
    if(defaultValue && defaultValue.value && defaultValue.value.length > 0){
      let newPhotoComponent = defaultValue.value.map((v: any,i:any) => {
        return {
          value: v,
          file: defaultValue.fileList[i]
        }
      })
      this.setState({photoComponent:newPhotoComponent})
    }
  }
  //#region  START HANDLES 
  handlePhotoChange = (idx: any) => (evt: any, isLoading: boolean, fileUploaded: any) => {
    const newInputPhoto = this.state.photoComponent.map((items: any, sidx: number) => {
      if (idx !== sidx) return items;
      return { ...items, value: evt, file: fileUploaded };
    });
    
    let valid = this.validationFunction(newInputPhoto, idx, isLoading)
    
    this.setState({ photoComponent: newInputPhoto, valid: valid }, () => {
      this.props.onChange({
        id: this.props.id,
        value: newInputPhoto.map((e: any) => e.value),
        validation: [!valid.includes(false)],
        file: newInputPhoto.map((e: any) => e.file),
      });
    });
    
  }

  handleAddPhotos = async () => {
    let newPhotos = this.state.photoComponent
    newPhotos.push({ value: '' })
    this.setState({ photoComponent: newPhotos })
  }

  handleRemovePhotos = (index: number) => async () => {
    let newInputPhoto = this.state.photoComponent.filter((section: any, sindex: number) => index !== sindex)
    let valid = this.validationFunction(newInputPhoto, index, false)
    this.setState({
      photoComponent: newInputPhoto,
      defaultValue: newInputPhoto,
      valid: valid
    });
    this.props.onChange({
      id: this.props.id,
      value: newInputPhoto.map((e: any) => e.value),
      file: newInputPhoto.map((e: any) => e.file),
      validation: valid
    });

  }
  //#endregion
  deleteIcon(index: number) {
    return (
      <Icon
        style={{ color: 'red', marginLeft: '20px', cursor: "pointer" }}
        type="close"
        onClick={this.handleRemovePhotos(index)}
      />
    )
  }

  validationFunction = (newInputPhoto: any, idx: number, isLoading: boolean) => {
    let valid = this.state.valid;
    if (isLoading || newInputPhoto[idx] === undefined) {
      valid[idx] = false
    } else {
      valid[idx] = newInputPhoto[idx].value !== "" ? true : false
    }
    return valid
  }
  handleDefaultValue(value: any,index : number){
    if(value && value.fileList && value.fileList[index])
    return {
      value : value.value[index],
      fileList: value.fileList[index]
    }
    return undefined
  } 
  render() {
    return (
      <AppContext.Consumer>
        {({ locale }) => (
          <Wrapper>
            <Form>
              <p>{this.props.description}</p>
              <FormItem>
                {this.state.photoComponent.map((items: any, index: number) => (
                  <div key={`${this.props.id}_pho_${index}`}>
                    <FieldsValidation
                      type={TypesValidation.IMAGE}
                      messageValidation={I18n.l("common.fieldRequired")}
                      handleOnChange={this.handlePhotoChange(index)}
                      validation={this.state.valid[index]}
                      defaultValue={this.handleDefaultValue(this.state.defaultValue,index)}
                      // defaultValue={items}
                      innerItems={this.props.repeat ? this.deleteIcon(index) : <span />}
                    />
                  </div>
                ))}
              </FormItem>
              {this.props.repeat &&
                < Button
                  onClick={this.handleAddPhotos}
                  style={{ marginLeft: '-15px', fontWeight: 'bold' }}
                  className="goepik-btn-border-main-withoutbold"
                >
                  <Icon type="plus" /> {I18n.l("common.addNew")}
                </Button>
              }
            </Form>
          </Wrapper>
        )}
      </AppContext.Consumer>
    );
  }
}

const Wrapper = styled.div`
  .button-style{
    margin-right: 20px;
    margin-bottom: 8px;
  }
`
